var map = {
	"./gallery_tournaments/cs2_01.jpg": "6317",
	"./gallery_tournaments/justdance_01.jpg": "48b4",
	"./gallery_tournaments/mariokart_01.jpg": "a155",
	"./gallery_tournaments/plateup_01.jpg": "10ae",
	"./gallery_tournaments/tft_01.jpg": "aa65",
	"./gallery_tournaments/yomi_01.jpg": "3470",
	"./gallery_vibes/2xko_01.jpg": "5413",
	"./gallery_vibes/beatsaber_01.jpg": "e79b",
	"./gallery_vibes/escaperoom_01.jpg": "47d6",
	"./gallery_vibes/tekken_01.jpg": "598d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a79a";